export default __webpack_public_path__ + "static/media/smart-design.2f7c2b83.png";